import React, { ReactNode } from 'react';

type IProps = {
  title: string | ReactNode;
  children: ReactNode;
  id?: string;
};

const AdminSettingSection: React.FC<IProps> = ({ title, children, id }) => (
  <div className="admin-setting-section" id={id}>
    <div className="admin-setting-section--title">{title}</div>
    <div className="admin-setting-section--children">{children}</div>
  </div>
);

export default AdminSettingSection;
